// src/layouts/MainLayout.jsx
import { Outlet } from 'react-router-dom';
import NavBar from '../components/NavBar';
import Footer from '../components/Footer';

export default function MainLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <NavBar />

      {/* main grows to fill remaining height */}
      <main className="flex-1">
        {/* <div className="mx-auto max-w-7xl px-6"> */}
          <Outlet />
        {/* </div> */}
      </main>

      <Footer
        links={[
          { name: 'About', href: '/aboutme' },
          { name: 'Blog', href: '/blog' },
          { name: 'Resume', href: '/resume' },
          { name: 'Contact', href: '/contact' },
        ]}
        socials={[{ name: 'LinkedIn', href: 'https://www.linkedin.com/in/arcode/' }]}
        owner="Angelo Ruiz"
        domain="angeloruiz.com"
      />
    </div>
  );
}
